import {  useEffect, useState } from 'react';
import clsx from 'clsx';
import {
  PaginatedGridLayout,
  StreamCall,
  StreamTheme,
  StreamVideo,
  VideoPreview,
  useCallStateHooks,
} from '@stream-io/video-react-sdk';
import {
  Call as CallType,
  StreamVideoClient as StreamVideoType,
} from '@stream-io/video-client';

import { LazyIcon } from '@getstream/ui-library/build';

import { useVideoContext } from '../VideoController/VideoController.context';

import {
  CustomCallControls,
  DefaultCallControls,
} from '../CustomCallControls/CustomCallControl';

import styles from './Call.module.css';

import { differenceInSeconds } from 'date-fns';

export const Call = ({
  call,
  client,
}: {
  call: CallType;
  client: StreamVideoType;
}) => {
  return (
    <StreamVideo client={client}>
      <StreamCall call={call}>
        <StreamTheme
          as="main"
          className={clsx(styles.customRootClass, 'relative')}
        >
          <InnerCall />
        </StreamTheme>
      </StreamCall>
    </StreamVideo>
  );
};

export const Elapsed = ({
  className,
  joinedAt,
}: {
  className?: string;
  joinedAt: number;
}) => {
  const rootClassName = clsx(styles.elapsedContainer, className);
  const [elapsed, setElapsed] = useState<any>();

  useEffect(() => {
    const interval = setInterval(() => {
      const elapsedSeconds = differenceInSeconds(
        Date.now(),
        new Date(joinedAt * 1000),
      );

      const date = new Date(0);
      date.setSeconds(elapsedSeconds);
      const format = date.toISOString().substring(14, 19);

      setElapsed(format);
    }, 1000);
    return () => clearInterval(interval);
  }, [joinedAt]);

  return (
    <div className={rootClassName}>
      <div className={styles.elapsed}>{elapsed}</div>
    </div>
  );
};

const InnerCall = () => {
  const { state, setCallState } = useVideoContext();
  const { customControls } = state;

  const { useCallCallingState, useParticipants, useLocalParticipant } = useCallStateHooks();
  const callingState = useCallCallingState();
  const localParticipant = useLocalParticipant();
  const participants = useParticipants();

  const me = participants?.[0];
  const joinedAt = Number(me?.joinedAt?.seconds);

  useEffect(() => {
    setCallState({
      callingState,
      localParticipant,
    });
  }, [callingState]);

  return (
    <>
      {callingState !== 'left' ? (
        <>
          <div className="top-controls mb-auto">
            <div className="avatar">a</div>
            {!!joinedAt && (
              <div className="time">
                <Elapsed joinedAt={joinedAt} />
              </div>
            )}
            <div className="participants">
              <LazyIcon name="participants" size={35} />
            </div>
          </div>
          {!joinedAt && <VideoPreview />}
          {!!joinedAt && (
            <>
              <PaginatedGridLayout />
              {customControls ? (
                <CustomCallControls />
              ) : (
                <DefaultCallControls />
              )}
            </>
          )}
        </>
      ) : (
        <div className="h-full w-full text-white flex items-center justify-center font-bold text-xl">
          Call Ended
        </div>
      )}
    </>
  );
};
